// credits.js
var Credits = pc.createScript('credits');

Credits.attributes.add('html', {
    type: 'asset',
    assetType: 'html'
});

Credits.attributes.add('css', {
    type: 'asset',
    assetType: 'css'
});

// initialize code called once per entity
Credits.prototype.initialize = function() {
    var app = this.app;
    
    var html = this.html.resource;
    var div = document.createElement("div");
    div.classList.add("container");
    div.innerHTML = html;
    document.body.appendChild(div);

    var style = pc.createStyle(this.css.resource);
    document.head.appendChild(style);

    var button = document.getElementById("mute-button");
    button.addEventListener("click", function () {
        if (app.systems.sound.volume > 0) {
            app.systems.sound.volume = 0;
            button.textContent = "Unmute";
        } else {
            app.systems.sound.volume = 1;
            button.textContent = "Mute";
        }
    }, this);
};


